import React from "react";
import Navbar from "../../components/modules/Navbar";
import './contactsStyles.css'
import { FaFacebook, FaMailBulk, FaYoutube, FaSearchLocation, FaInstagram } from 'react-icons/fa'
import logoToss from '../../assets/logo_toss_blanc.png'
import ScrollTrigger from 'gsap/ScrollTrigger'
import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { useEffect, useRef, useState } from 'react'
import Footer from "../../components/modules/Footer";
import { useTranslation } from "react-i18next";

import emailjs from '@emailjs/browser';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const Contacts = () => {
    const { t } = useTranslation('common');

    const [General, setGeneral] = useState(false);
    const [Sports, setSports] = useState(false);
    const [Inscription, setInscription] = useState(false);
    const [Logement, setLogement] = useState(false);
    const [Autres, setAutres] = useState(false);
    const [messageSend, setMessageSend] = useState(false);

    const form = useRef();
    const sendEmail = (e) => {
        e.preventDefault();

        emailjs.sendForm('service_e50wboa', 'template_eqvvx3c', form.current, 'S1P0iAQvvOT-psCdf')
            .then((result) => {

                e.target.reset();
                setMessageSend(true);
            }, (error) => {
                console.log(error.text);
            });
    };



    const handleChange = (data) => {
        if (data === 'general') {
            setGeneral(!General)
            setSports(false)
            setInscription(false)
            setLogement(false)
            setAutres(false)

        }
        if (data === 'sports') {
            setSports(!Sports)
            setGeneral(false)
            setInscription(false)
            setLogement(false)
            setAutres(false)
        }
        if (data === 'logement') {
            setSports(false)
            setGeneral(false)
            setInscription(false)
            setLogement(!Logement)
            setAutres(false)
        }
        if (data === 'inscription') {
            setSports(false)
            setGeneral(false)
            setInscription(!Inscription)
            setLogement(false)
            setAutres(false)
        }
        if (data === 'autres') {
            setSports(false)
            setGeneral(false)
            setInscription(false)
            setLogement(false)
            setAutres(!Autres)
        }
    }

    const FadeUpScroll = (elem) => {
        gsap.fromTo(
            elem,

            {
                y: 20,
                opacity: 0
            },
            {
                y: 0,
                opacity: 1,
                duration: 1,
                scrollTrigger: {
                    trigger: elem,
                    start: "top center",
                    end: "bottom center",

                    toggleActions: "play none pause none",



                }


            }

        )

    }
    useEffect(() => {
        FadeUpScroll('#card1')
        FadeUpScroll('#card2')

    }, [])

    return (
        <div>
            <Navbar scroll='true' />
            <div className="contacts">
                <div>
                    <h1> {t('contact.title')}</h1>
                    <h3> {t('contact.subtitle')}</h3>
                    <h4 className="messageSend"> {messageSend ? 'Message bien envoyé, nous tentons de te répondre au plus vite' : ''}</h4>
                </div>

                <div className="contacts-card-container">
                    <div className="contacts-card">
                        <div className="contacts-card-black">
                            <h2> Contact information</h2>
                            <div className="contacts-card-informations">
                                <div className="contacts-card-mail">
                                    <FaMailBulk className="mail" />
                                    <a href='mailto:toss@cs-sports.fr'>toss@cs-sports.fr</a>
                                </div>
                                <div className="contacts-card-location">
                                    <FaSearchLocation className="location" />
                                    <div>
                                        <p> 3 rue Joliot Curie <br /> Gif-sur-Yvette, 91190</p>
                                    </div>
                                </div>
                            </div>
                            <div className="contacts-card-social-media">
                                <a href='https://www.youtube.com/@bdscentralesupelec6461/videos'> <FaYoutube /></a>
                                <a href='https://www.instagram.com/toss_cs/?hl=fr'> <FaInstagram /></a>
                                <a href='https://www.facebook.com/toss.cs/?locale=fr_FR'> <FaFacebook /></a>
                            </div>
                            <div className="circle-1">
                            </div>
                            <div className="circle-3">
                            </div>
                            <div className="circle-2">
                                <img  src={logoToss} alt="" />
                            </div>
                        </div>
                        <div className="contacts-card-white">
                            <form ref={form} onSubmit={sendEmail}>
                                <div className="contact-form">
                                    <div className="input-container">
                                        <h4> {t('contact.firstname')}</h4>
                                        <input type="text" name='firstname' />

                                    </div>
                                    <div className="input-container">
                                        <h4 className="bold"> {t('contact.lastname')}</h4>
                                        <input type='text' name='lastname' />
                                    </div>
                                </div>
                                <div className="contact-form">
                                    <div className="input-container">
                                        <h4> Email</h4>
                                        <input type='email' name='user_email' />
                                    </div>
                                    <div className="input-container">
                                        <h4 className="bold"> {t('contact.phonenumer')}</h4>
                                        <input type='tel' name='user_phone' />
                                    </div>
                                </div>
                                <div className="contact-form-subject">
                                    <h4> {t('contact.subject')}</h4>
                                    <div className="contact-form-checkbox">
                                        <div>
                                            <input type="checkbox" className="checkbox-round" name='subject' value='[TOSS] General' onChange={() => handleChange('general')} checked={General} />
                                            <p> {t('contact.answer1')}</p>
                                        </div>
                                        <div>
                                            <input type="checkbox" className="checkbox-round" name='subject' value='[TOSS] Sports' onChange={() => handleChange('sports')} checked={Sports} />
                                            <p> Sports</p>
                                        </div>
                                        <div>
                                            <input type="checkbox" className="checkbox-round" name='subject' value='[TOSS] Inscription' onChange={() => handleChange('inscription')} checked={Inscription} />
                                            <p> {t('contact.answer3')}</p>
                                        </div>
                                        <div>
                                            <input type="checkbox" className="checkbox-round" name='subject' value='[TOSS] Logement' onChange={() => handleChange('logement')} checked={Logement} />
                                            <p> {t('contact.answer4')}</p>
                                        </div>
                                        <div>
                                            <input type="checkbox" className="checkbox-round" name='subject' value='[TOSS] Autres' onChange={() => handleChange('autres')} checked={Autres} />
                                            <p> {t('contact.answer5')}</p>
                                        </div>

                                    </div>
                                </div>
                                <div className="contact-form-message">
                                    <h4> Message</h4>
                                    <input type='text' placeholder="Ecris ton message..." name='message' />
                                    <button type="submit"> {t('contact.button')}</button>
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
            </div>
            <div className="contact-person">
                <h2> {t('contact.title2')}</h2>
                <div className="contact-person-container">
                    <div className="contact-person-card card1" id='card1'>
                        <div className="circle-person1"></div>
                        <div className="circle-person2"></div>
                        <div className="circle-person3"></div>

                        <h4> {t('contact.comite')}</h4>
                        <div >
                            <div className="contact-person-content">
                                <h5> Baptiste Beaudel</h5>
                                <div className="contact-person-content-mail">
                                    <FaMailBulk className="mail1" />
                                    <a href='mailto:baptiste.beaudel@student-cs.fr'>baptiste.beaudel@student-cs.fr</a>
                                </div>

                                <div className="line-vertical">

                                </div>
                                <h6> {t('contact.committeeRole1')}</h6>

                            </div>
                            <div className="contact-person-content">
                                <h5> Bertille Grillier</h5>
                                <div className="contact-person-content-mail">
                                    <FaMailBulk className="mail1" />
                                    <a href='mailto:bertille.grillier@student-cs.fr'>bertille.grillier@student-cs.fr</a>
                                </div>

                                <div className="line-vertical">

                                </div>
                                <h6> {t('contact.committeeRole2')}</h6>

                            </div>
                            <div className="contact-person-content">
                                <h5> Victor Piroth</h5>
                                <div className="contact-person-content-mail">
                                    <FaMailBulk className="mail1" />
                                    <a href='mailto:victor.piroth@student-cs.fr'>victor.piroth@student-cs.fr</a>
                                </div>

                                <div className="line-vertical">

                                </div>
                                <h6> {t('contact.committeeRole3')}</h6>

                            </div>
                        </div>

                    </div>
                    <div className="contact-person-card card2" id='card2'>
                        <div className="circle-person4"></div>
                        <div className="circle-person5"></div>

                        <h4>{t('contact.member')}</h4>
                        <div className="contact-persons">
                            <div className="contact-persons-col1">
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Dillan Reggane</h5>
                                        <a href="mailto:dillan.reggane@student-cs.fr">dillan.reggane@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole1')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Lucas Kosmalski</h5>
                                        <a href="mailto:lucas.kosmalski@student-cs.fr">lucas.kosmalski@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole2')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Pierre Solans</h5>
                                        <a href="mailto:pierre.solans@student-cs.fr">pierre.solans@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole3')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Sébastien Aliane</h5>
                                        <a href="mailto:sebastien.aliane@student-cs.fr">sebastien.aliane@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole4')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Mathilde Dziechciarz </h5>
                                        <a href="mailto:mathilde.dziechciarz@student-cs.fr">mathilde.dziechciarz@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole5')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Laure de Sury</h5>
                                        <a href="mailto:laure.desurydaspremont@student-cs.fr">laure.desurydaspremont@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole6')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Alix Caboufigue</h5>
                                        <a href="mailto:alix.caboufigue@student-cs.fr">alix.caboufigue@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole7')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Merwan Bennani</h5>
                                        <a href="mailto:merwan.bennani@student-cs.fr">merwan.bennani@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole8')}</h6>
                                </div>
                            </div>
                            <div className="contact-persons-col2">
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Matthieu Anquetil</h5>
                                        <a href="mailto:matthieu.anquetil@student-cs.fr">matthieu.anquetil@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole9')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Rémi Vergara</h5>
                                        <a href="mailto:remi.vergara@student-cs.fr">remi.vergara@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole10')} </h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Mathurin Le Brun</h5>
                                        <a href="mailto:mathurin.le-brun@student-cs.fr">mathurin.le-brun@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole11')} </h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Enguerrand de Jaegere</h5>
                                        <a href="mailto:enguerrand.de-jaegere@student-cs.fr">enguerrand.de-jaegere@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole12')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Maxime Fauquet</h5>
                                        <a href="mailto:maxime.fauquet@student-cs.fr">maxime.fauquet@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole13')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Liv Craen</h5>
                                        <a href="mailto:liv.craen@student-cs.fr">liv.craen@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole14')}</h6>
                                </div>
                                <div className="contact-persons-row">
                                    <div>
                                        <h5> Lucas Desgranges</h5>
                                        <a href="mailto:lucas.desgranges@student-cs.fr">lucas.desgranges@student-cs.fr</a>
                                    </div>
                                    <h6> {t('contact.memberRole15')}</h6>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Contacts